import { useQuery } from "@tanstack/react-query"
import { client } from "@/api"

interface DashboardData {
  stats: {
    users: {
      total: number
      verified: number
      admins: number
      active: number
      trends: {
        newLastWeek: number
      }
    }
    teams: {
      total: number
      active: number
    }
    games: {
      total: number
      trends: {
        newLastWeek: number
      }
    }
    clips: {
      total: number
      trends: {
        newLastWeek: number
      }
    }
  }
  // Measured or null: `available` is false until the Analytics API or a completed
  // "Refresh breakdown" on the Storage page has measured the bucket.
  storage: {
    used: number | null
    usedGB: number | null
    fileCount: number | null
    available: boolean
    source: "analytics" | "breakdown" | null
    measuredAt: string | null
    partial: boolean
  }
  activity: {
    recent: Array<{
      type: string
      description: string
      timestamp: string
    }>
  }
}

export function useDashboard() {
  return useQuery({
    queryKey: ["admin", "dashboard"],
    queryFn: async () => {
      const response = await (client).admin.stats.dashboard.$get()
      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data")
      }
      return response.json() as Promise<DashboardData>
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  })
}